import { create } from 'zustand';

interface ConfirmDialogOptions {
  title: string;
  message: string;
  confirmLabel?: string;
  onConfirm: () => void;
}

interface ConfirmDialogStore {
  open: boolean;
  title: string;
  message: string;
  confirmLabel: string;
  onConfirm: () => void;
  confirm: (opts: ConfirmDialogOptions) => void;
  cancel: () => void;
}

export const useConfirmDialog = create<ConfirmDialogStore>((set) => ({
  open: false,
  title: '',
  message: '',
  confirmLabel: 'Delete',
  onConfirm: () => {},
  confirm: ({ title, message, confirmLabel = 'Delete', onConfirm }) =>
    set({ open: true, title, message, confirmLabel, onConfirm }),
  cancel: () => set({ open: false }),
}));
